import { StyleSheet } from 'react-native';
import { neutrals } from '../../theme/colors';

export const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    width: '100%',
    height: '100%',
  },
  oveflowHidden: {
    overflow: 'hidden',
  },
  oveflowVisible: {
    opacity: 0.2,
  },
  layerUpdate: {
    opacity: 0.5,
    backgroundColor: neutrals.white,
  },
  image: {
    // position: 'absolute',
    // top: 0,
    // left: 0,
    resizeMode: 'cover',
    width: '100%',
    height: '100%',
  },
});
